// pages/products/signage/SolarFiberSign.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';
import {
  InfoSection,
  TypeBlock
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';

const SolarFiberSign = () => {

  const compositionGroups = [
    {
      items: [
        { src: '/images/products/signage/speed-limit-light.webp', label: '특허 제 10-1469887호 \n발광형 제한속도 표시장치' },
        { src: '/images/products/signage/light-sign.webp', label: '특허 제 10-1450240호 \n발광형 표지판' },
      ],
    },
  ];

  
  return (
    <>
      <HeroSection
        title={`태양광 광섬유 발광형 \n교통안전표지판`}
        subtitle={`야간이나 악천후에도 뛰어난 시인성으로 \n사고를 예방합니다`}
        backgroundImage="/images/products/signage/light-sign2.webp"
        breadcrumbs={[
            { label: '홈', path: '/' },
            { label: '도로 안내표지시스템', path: '/products/signage' },
            { label: '태양광 광섬유 발광형 교통안전표지판' }, // 현재 페이지는 path 없음
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`시야 확보가 어려운 환경에서도, 안전한 교통을 위해`}
        title={`태양광 광섬유 발광형 \n교통안전표지판`}
        description={`기존 표지판에 비해 균일하고 강한 조명으로 탁월한 시인성과 판독성을 제공하여 표지 내용 전달력이 뛰어나고 사고 예방 효과가 매우 우수합니다.\n
            특히 사고다발지역, 안개나 악천후가 잦은 지역, 과속 우려가 있는 도로 구간에서 운전자의 주의 환기와 사고 방지에 탁월한 효과를 발휘하며, 야간이나 시야 확보가 어려운 환경에서도 안전성과 신뢰성을 크게 향상시킵니다.`}
        images={[
          '/images/products/signage/solar-fiber-sign.webp',
          '/images/products/signage/solar-light-sign.webp',
        ]}
        badgeImages={[
            "/images/logo/Nara.webp",
        ]}
      />

      <SectionDivider />
      
      <InfoSection title="제품 구성도">
        <TypeBlock groups={compositionGroups} />
      </InfoSection>


      <ProductDetailNav
        category="signage"
        currentPath="/products/signage/solar-fiber-sign"
        listPath="/products/signage"
      />


      <CTASection />
    </>
  );
};

export default SolarFiberSign;
